export { default } from './CardEventSchedules.vue'
